import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqItems: FAQItem[] = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No. Está diseñada para principiantes desde cero.'
}, {
  question: '¿Cómo recibo la guía y los bonos?',
  answer: 'Al instante, por email. Son PDFs descargables.'
}, {
  question: '¿Funciona desde el celular?',
  answer: 'Sí. Podés leer y seguir la guía desde el celular, tablet o computadora.'
}, {
  question: '¿Los materiales son fáciles de conseguir en USA?',
  answer: 'Sí. Todo está pensado para conseguirse en Walmart, Michaels, Joann o Amazon.'
}, {
  question: '¿Puedo hacer el bikini en 24 horas reales?',
  answer: 'Sí, si sigues la ruta del Bono #3 (Checklist 24h Sin Trabarte). Incluso si avanzás por bloques cortos de 1–2h.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-239">
      <div className="max-w-[680px] mx-auto" data-id="element-240">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-241">
          Preguntas Frecuentes
        </h2>

        <div className="divide-y divide-gray-200" data-id="element-242">
          {faqItems.map((item, index) => <div key={index} data-id="element-243">
              <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between py-5 text-left cursor-pointer group" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-244">
                <span className="font-body font-semibold text-dark-gray text-base md:text-lg pr-4" data-id="element-245">
                  {item.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-pink-dark flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-246" />
              </button>
              <div id={`faq-answer-${index}`} role="region" className={`overflow-hidden transition-all duration-300 ease-out ${openIndex === index ? 'max-h-48 pb-5' : 'max-h-0'}`} data-id="element-247">
                <p className="font-body text-medium-gray text-base leading-relaxed" data-id="element-248">
                  {item.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}